var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.5dbf10dfc9bd51634fc588d859d0e046.svg#b';
                    var viewUrl = 'sprites.5dbf10dfc9bd51634fc588d859d0e046.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };